import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Router } from '@angular/router';
import { Injectable } from '@angular/core';

import { AES, enc } from 'crypto-js';

import * as fromUserSelector from './../../pages/user/state/user.selectors';

import * as fromAppSelectors from './../state/app.selector';
import { AppState } from '../state/app.reducer';

@Injectable({
	providedIn: 'root',
})
export class AuthService {
	private logged: boolean;

	constructor(
		private router: Router,
		private http: HttpClient,
		private store: Store<AppState>
	) {}

	/**
	 * Returns authentication state
	 */
	public get isAuthenticated(): boolean {
		if (
			localStorage.getItem('accessToken') != undefined &&
			localStorage.getItem('idToken') != undefined
		) {
			this.loadCredentials();
		}
		return this.logged;
	}

	/**
	 * Loads user credentials on localStorage
	 */
	public loadCredentials(): void {
		if (
			localStorage.getItem('accessToken') != undefined &&
			localStorage.getItem('idToken') != undefined
		) {
			this.logged = true;
		} else {
			this.logged = false;
		}
	}

	public get userLocale(): string {
		let locale;
		this.store.select(fromUserSelector.selectUser).subscribe((user) => {
			if (user) {
				locale = user.locale;
			}
		});

		return locale;
	}

	/**
	 * Set credentials in local storage
	 * Refresh Token isn't required because it's not returned on token refresh request
	 * @param accessToken Access token key
	 * @param idToken Authorization Token key
	 * @param refreshToken Refresh Token key
	 */
	public setCredentials(
		accessToken: string,
		idToken: string,
		refreshToken?: string
	): void {
		const accessT = AES.encrypt(accessToken, environment.AES_KEY).toString();
		const idT = AES.encrypt(idToken, environment.AES_KEY).toString();
		let refT;

		if (refreshToken) {
			refT = AES.encrypt(refreshToken, environment.AES_KEY).toString();
			localStorage.setItem('refreshToken', refT);
		}

		localStorage.setItem('accessHour', new Date().toString());

		localStorage.setItem('accessToken', accessT);
		localStorage.setItem('idToken', idT);

		this.logged = true;
	}

	/**
	 * Returns the ID Token
	 *
	 * @readonly
	 * @type {string}
	 * @memberof ComplaintsService
	 */
	public get idToken(): string {
		return AES.decrypt(
			localStorage.getItem('idToken'),
			environment.AES_KEY
		).toString(enc.Utf8);
	}

	/**
	 * Returns the Refresh Token
	 *
	 * @readonly
	 * @type {string}
	 * @memberof AuthService
	 */
	public get refreshToken(): string {
		return AES.decrypt(
			localStorage.getItem('refreshToken'),
			environment.AES_KEY
		).toString(enc.Utf8);
	}

	/**
	 * Returns the Access Token
	 *
	 * @readonly
	 * @type {string}
	 * @memberof AuthService
	 */
	public get accessToken(): string {
		return AES.decrypt(
			localStorage.getItem('accessToken'),
			environment.AES_KEY
		).toString(enc.Utf8);
	}

	/**
	 * User logout, invalidating access token on Cognito user Pool
	 */
	public logout(): void {
		const isSuper = Boolean(localStorage.getItem('superUser'));
		let url;
		if (isSuper) {
			url = environment.backend.userURL + '/super/logout';
		} else {
			url = environment.backend.userURL + '/op/logout';
		}

		localStorage.clear();

		this.http
			.get(url)
			.subscribe()
			.add(() => {
				localStorage.clear();
				this.logged = false;
				this.router.navigate(['auth']);
			});
	}
}
